import React from 'react';
import LeftSide from '../../components/auth/SignIn/LeftSide';
import RightSide from '../../components/auth/SignUp/RightSide';

const text = {
  header: 'Sign Up',
  para: 'Create an account to serve your services.',
};

const SignUp = () => {
  return (
    <div className="lg:flex">
      <LeftSide route='signup' header={text.header} para={text.para} add="" />
      <div className="lg:flex-grow lg:w-2/4 min-h-screen max-h-full">
        <RightSide />
      </div>
    </div>
  );
};

export default SignUp;
